export type LottieEffectModule = {
    default: unknown;
};

export type LottieEffectLoader = () => Promise<LottieEffectModule>;

export const LOTTIE_EFFECT_TRIGGERS: Record<string, LottieEffectLoader> = {
    ':chat-lottie-effect-heart-jackpot': () =>
        import('../assets/lottie/effect/trh-full-heart-jackpot-finale.json'),
    ':chat-lottie-effect-mega-star': () =>
        import('../assets/lottie/effect/trh-full-mega-star-explosion.json'),
};

export const isChatLottieEffectTrigger = ({
    ch,
    message,
}: {
    ch?: boolean;
    message?: string;
}) =>
    Boolean(
        ch &&
            message &&
            Object.prototype.hasOwnProperty.call(
                LOTTIE_EFFECT_TRIGGERS,
                message
            )
    );
